/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { CreateRenewalRequest, CreateRenewalResponse } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Renew customer on to new agreements and set payment schedule
 */
export const createRenewal = (
  billingAccountId: number,
  createRenewalRequest: CreateRenewalRequest,
  options?: SecondParameter<typeof backofficeRequest<CreateRenewalResponse>>,
) => {
  return backofficeRequest<CreateRenewalResponse>(
    {
      url: `/accounts/${billingAccountId}/create-renewal`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createRenewalRequest,
    },
    options,
  )
}
export type CreateRenewalResult = NonNullable<
  Awaited<ReturnType<typeof createRenewal>>
>
